import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { MatCardModule } from "@angular/material/card";
import { MatListModule } from "@angular/material/list";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatMenuModule } from "@angular/material/menu";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MAT_DATE_LOCALE, MatNativeDateModule } from "@angular/material/core";
import { MatTabsModule } from "@angular/material/tabs";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { MatDialogModule } from "@angular/material/dialog";
import {
  DatePipe,
  HashLocationStrategy,
  LocationStrategy,
} from "@angular/common";
import { MatRadioModule } from "@angular/material/radio";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { MatBadgeModule } from "@angular/material/badge";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { NgxSpinnerModule } from "ngx-spinner";
import { QRCodeModule } from "angularx-qrcode";
import { NgxFileDropModule } from "ngx-file-drop";
import { MatChipsModule } from "@angular/material/chips";
import {
  MatSlideToggleModule,
  _MatSlideToggleRequiredValidatorModule,
} from "@angular/material/slide-toggle";

import { EventsComponent } from "./events/events.component";
import { ListingComponent } from "./listing/listing.component";
import { ReportComponent } from "./report/report.component";
import {
  UserComponent,
  add_edit_user,
  view_event,
} from "./user/user.component";
import { LoginComponent } from "./login/login.component";
import {
  AdminComponent,
  SelectEventComponent,
  qrcodeComponent,
} from "./admin/admin.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { AddeventComponent } from "./events/addevent/addevent.component";
import { EditeventComponent } from "./events/editevent/editevent.component";
import { ToastrModule } from "ngx-toastr";
import { SettingComponent } from "./setting/setting.component";
import {
  AdminUserComponent,
  AddAdminUserComponent,
} from "./admin-user/admin-user.component";
import { CardDesignComponent } from "./card-design/card-design.component";
import { AddlistingComponent } from "./listing/addlisting/addlisting.component";
import { EditlistingComponent } from "./listing/editlisting/editlisting.component";
import { RegistrationComponent } from "./registration/registration.component";
import { RegistrationSettingComponent } from "./registration-setting/registration-setting.component";
import {
  RegistrationListComponent,
  EditRegistration,
  SendCard,
  AssignTicket,
  add_registration,
  CashPay,
} from "./registration-list/registration-list.component";
import {
  EventUserComponent,
  AddEventUserComponent,
} from "./event-user/event-user.component";
import { SanitizeHtmlPipe } from "src/services/desc.pipe";
import { Card1Component } from "./card-design/card1/card1.component";
import { Card2Component } from "./card-design/card2/card2.component";
import { Card3Component } from "./card-design/card3/card3.component";
import {
  ScanningPointComponent,
  add_edit_scanning,
} from "./scanning-point/scanning-point.component";
import { AppRegistrationSettingComponent } from "./app-registration-setting/app-registration-setting.component";
import { AppCardDesignComponent } from "./app-card-design/app-card-design.component";
import { AppCard1Component } from "./app-card-design/app-card1/app-card1.component";
import { AppCard2Component } from "./app-card-design/app-card2/app-card2.component";
import { AppCard3Component } from "./app-card-design/app-card3/app-card3.component";
import { AppAddEventComponent } from "./app-add-event/app-add-event.component";
import { Idcard1Component } from "./idcard1/idcard1.component";
import { Idcard2Component } from "./idcard2/idcard2.component";
import { Idcard3Component } from "./idcard3/idcard3.component";
import { CustomCardComponent } from "./custom-card/custom-card.component";
import { PaymentComponent } from "./payment/payment.component";
import { PaymentSettingComponent } from "./payment-setting/payment-setting.component";
import {
  AdvertiseComponent,
  AddAdvertiseComponent,
} from "./advertise/advertise.component";
import { SuccessComponent } from "./success/success.component";
import {
  CouponCodeComponent,
  add_coupon,
} from "./coupon-code/coupon-code.component";
import { AppPaymentSettingComponent } from "./app-payment-setting/app-payment-setting.component";
import { AppCustomCardComponent } from "./app-custom-card/app-custom-card.component";
import { PushNotificationComponent } from "./push-notification/push-notification.component";
import {
  TicketCategoryComponent,
  add_edit_ticket_category,
} from "./ticket-category/ticket-category.component";
import { TicketsComponent, add_edit_ticket } from "./tickets/tickets.component";
import {
  EventTypeComponent,
  AddEventTypeComponent,
} from "./event-type/event-type.component";
import { AddTicketCategoryComponent } from "./ticket-category/add-ticket-category/add-ticket-category.component";
import {
  StallComponent,
  add_edit_stall,
  stall_layout,
  add_edit_sowner,
} from "./stall/stall.component";
import {
  MystallComponent,
  add_edit_mystall,
} from "./mystall/mystall.component";
import { StallScanComponent } from "./mystall/stall-scan/stall-scan.component";
import {
  StallCategoryComponent,
  add_edit_category,
} from "./stall-category/stall-category.component";
import {
  StallProductComponent,
  add_edit_product,
} from "./stall-product/stall-product.component";
import { EditStallComponent } from "./mystall/edit-stall/edit-stall.component";
import { GalleryComponent, addgallery } from "./gallery/gallery.component";
import { EditgalleryComponent } from "./gallery/editgallery/editgallery.component";
import { ImageCropperModule } from "ngx-image-cropper";
import { ImageOptionsDialogComponent } from "./registration/image-options-dialog.component";
import { RsvpComponent } from "./rsvp/rsvp.component";
import { CatalogueInquiryComponent } from "./catalogue-inquiry/catalogue-inquiry.component";
import { MycatalogueComponent } from "./mycatalogue/mycatalogue.component";
import { TransactionsComponent } from "./transactions/transactions.component";
import { AppAddTicketCategoryComponent } from "./app-add-ticket-category/app-add-ticket-category.component";
import { EditTicketCategoryComponent } from "./ticket-category/edit-ticket-category/edit-ticket-category.component";
import { BlankPageComponent } from "./blank-page/blank-page.component";
import { AppEditTicketCategoryComponent } from "./app-edit-ticket-category/app-edit-ticket-category.component";
import { ArtistsComponent, add_artist } from "./artists/artists.component";
import { SponsorComponent, add_sponsor } from "./sponsor/sponsor.component";
import { StallFormComponent } from "./stall-form/stall-form.component";
import { CreateEventStallComponent } from "./mystall/create-event-stall/create-event-stall.component";
import { MAT_DATE_FORMATS } from "@angular/material/core";

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD/MM/YYYY",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
import {
  AppArtistsComponent,
  app_add_artist,
} from "./app-artists/app-artists.component";
import {
  AppSponsorComponent,
  app_add_sponsor,
} from "./app-sponsor/app-sponsor.component";
import { AppCreateEventStallComponent } from "./app-create-event-stall/app-create-event-stall.component";
import { StallCataloguesListComponent } from "./stall-catalogues-list/stall-catalogues-list.component";
import { SoEventDetailComponent } from "./so-event-detail/so-event-detail.component";
import { RegistrationEditComponent } from "./registration-edit/registration-edit.component";
import { DashboardSummaryCardComponent } from "./dashboard/components/dashboard-summary-card/dashboard-summary-card.component";
import { AnalyticsFilterComponent } from "./dashboard/components/analytics-filter/analytics-filter.component";
import { DashboardSectionComponent } from "./dashboard/components/dashboard-section/dashboard-section.component";
import { ChartWidgetComponent } from "./dashboard/components/chart-widget/chart-widget.component";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AuthInterceptor } from "src/services/auth.interceptor";
import { SuccessRegistrationComponent } from './registration/success-registration/success-registration.component';
import {
  ProductQrComponent,
  AddProductQrBatchDialog,
  ProductQrCodesDialog,
  ProductQrClaimComponent,
  PrintStickersDialog
} from "./product-qr/product-qr.component";
import { ProductQrScanAnalyticsComponent } from "./product-qr/product-qr-scan-analytics.component";
import { StallUersComponent } from './mystall/stall-uers/stall-uers.component';
import { RedeemrequestsComponent } from './redeemrequests/redeemrequests.component';
import { ViewServicesComponent } from './view-services/view-services.component';
import { ViewServiceDetailComponent } from './view-services/view-service-detail/view-service-detail.component';
import { BlogComponent } from './blog/blog.component';
import { BlogViewDialogComponent } from "./blog/blog-view-dialog/blog-view-dialog.component";
import { BlogFormDialogComponent } from './blog/blog-form-dialog/blog-form-dialog.component';
import { QuillModule } from "ngx-quill";

@NgModule({
  declarations: [
    AppComponent,
    EventsComponent,
    ReportComponent,
    ListingComponent,
    UserComponent,
    add_edit_user,
    view_event,
    LoginComponent,
    AdminComponent,
    SelectEventComponent,
    qrcodeComponent,
    DashboardComponent,
    AddeventComponent,
    EditeventComponent,
    SettingComponent,
    AdminUserComponent,
    AddAdminUserComponent,
    CardDesignComponent,
    AddlistingComponent,
    EditlistingComponent,
    RegistrationComponent,
    ImageOptionsDialogComponent,
    RegistrationSettingComponent,
    RegistrationListComponent,
    EditRegistration,
    SendCard,
    CashPay,
    AssignTicket,
    add_registration,
    EventUserComponent,
    AddEventUserComponent,
    SanitizeHtmlPipe,
    Card1Component,
    Card2Component,
    Card3Component,
    ScanningPointComponent,
    add_edit_scanning,
    AppRegistrationSettingComponent,
    AppCardDesignComponent,
    AppCard1Component,
    AppCard2Component,
    AppCard3Component,
    AppAddEventComponent,
    Idcard1Component,
    Idcard2Component,
    Idcard3Component,
    CustomCardComponent,
    PaymentComponent,
    PaymentSettingComponent,
    AdvertiseComponent,
    AddAdvertiseComponent,
    SuccessComponent,
    CouponCodeComponent,
    add_coupon,
    AppPaymentSettingComponent,
    AppCustomCardComponent,
    PushNotificationComponent,
    TicketCategoryComponent,
    add_edit_ticket_category,
    TicketsComponent,
    add_edit_ticket,
    EventTypeComponent,
    AddEventTypeComponent,
    AddTicketCategoryComponent,
    StallComponent,
    stall_layout,
    add_edit_stall,
    add_edit_sowner,
    MystallComponent,
    add_edit_mystall,
    StallScanComponent,
    StallCategoryComponent,
    add_edit_category,
    StallProductComponent,
    add_edit_product,
    EditStallComponent,
    GalleryComponent,
    addgallery,
    EditgalleryComponent,
    RsvpComponent,
    CatalogueInquiryComponent,
    MycatalogueComponent,
    TransactionsComponent,
    AppAddTicketCategoryComponent,
    EditTicketCategoryComponent,
    BlankPageComponent,
    AppEditTicketCategoryComponent,
    ArtistsComponent,
    add_artist,
    SponsorComponent,
    add_sponsor,
    StallFormComponent,
    CreateEventStallComponent,
    AppArtistsComponent,
    app_add_artist,
    AppSponsorComponent,
    app_add_sponsor,
    AppCreateEventStallComponent,
    StallCataloguesListComponent,
    SoEventDetailComponent,
    RegistrationEditComponent,
    DashboardSummaryCardComponent,
    AnalyticsFilterComponent,
    DashboardSectionComponent,
    ChartWidgetComponent,
    SuccessRegistrationComponent,
    ProductQrComponent,
    AddProductQrBatchDialog,
    ProductQrCodesDialog,
    ProductQrClaimComponent,
    PrintStickersDialog,
    ProductQrScanAnalyticsComponent,
    StallUersComponent,
    RedeemrequestsComponent,
    ViewServicesComponent,
    ViewServiceDetailComponent,
    BlogComponent,
    BlogViewDialogComponent,
    BlogFormDialogComponent,
  ],
  imports: [
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatTabsModule,
    MatRadioModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatSortModule,
    MatPaginatorModule,
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatCardModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatInputModule,
    MatMenuModule,
    MatTableModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatCheckboxModule,
    AngularEditorModule,
    MatBadgeModule,
    SweetAlert2Module,
    NgxMaterialTimepickerModule,
    NgxSpinnerModule,
    MatChipsModule,
    QRCodeModule,
    NgxFileDropModule,
    ImageCropperModule,
    MatSlideToggleModule,
    QuillModule.forRoot(),
    _MatSlideToggleRequiredValidatorModule,
    ToastrModule.forRoot({
      timeOut: 1500,
      progressBar: true,
      progressAnimation: "increasing",
      positionClass: "toast-top-right",
    }),
  ],
  providers: [
    DatePipe,
    { provide: MAT_DATE_LOCALE, useValue: "en-IN" },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule { }
